import * as EpisodeService from "@/services/EpisodeService"
import { notificationError } from "@/common/helpers/notifications.helper"

const resolveIsAiPodcast = (params, rootGetters) => {
  if (typeof params.isAiPodcast === "boolean") return params.isAiPodcast
  return !!rootGetters["Podcast/isAiPodcast"]
}

export const getEpisodes = async ({ commit, rootGetters }, { podcastKey, params }) => {
  try {
    const isAiPodcast = resolveIsAiPodcast(params, rootGetters)
    const result = await EpisodeService.getEpisodes(podcastKey, params, isAiPodcast)
    commit("setEpisodes", result.data)
    return result
  } catch (e) {
    console.error(e)
    await notificationError("Unable to load episodes. Please try again.", "Failed to load episodes")
    throw e
  }
}

export const getEpisode = async ({ commit, rootGetters }, { podcastKey, episodeKey, isAiPodcast }) => {
  try {
    const isAi = resolveIsAiPodcast({ isAiPodcast }, rootGetters)
    const episode = await EpisodeService.getEpisode(podcastKey, episodeKey, isAi)
    commit("setEpisode", episode)
    return episode
  } catch (e) {
    console.error(e)
    await notificationError("Unable to load episode. Please try again.", "Failed to load episode")
    throw e
  }
}

export const updateEpisode = async ({ commit, rootGetters }, data) => {
  try {
    const isAiPodcast = resolveIsAiPodcast(data, rootGetters)
    const episode = await EpisodeService.updateEpisode(data, isAiPodcast)
    commit("setEpisode", episode)
    return episode
  } catch (e) {
    console.error(e)
    throw e
  }
}

export const resetEpisode = ({ commit }) => {
  commit("resetEpisode")
}
